import { bazaarApi, helperApi } from '../api/endpoints';
import { flushAllStations } from '../helperStations/flush';
import { flushAllIntakes } from '../intake/flush';
import { sendWaitingRegisters } from '../pos/backgroundSend';
import { currentPerson } from './currentPerson';

/** So lange wartet das Abmelden höchstens auf das Senden (Hallen-WLAN): Danach wird trotzdem abgemeldet. */
export const LOGOUT_FLUSH_BUDGET_MS = 6000;

/**
 * Vor dem Abmelden: wartende Verkäufe der Kassen und Rückgabe-Scans der Stationen und Annahme-Scans dieses Geräts senden, solange das Konto der
 * Person noch angemeldet ist. Was nicht hinausgeht (kein Netz, Frist, Fehler), bleibt auf dem Gerät und gehört weiter dieser
 * Person: Es geht unter ihrem Konto hinaus, wenn sie sich wieder anmeldet, nie unter dem Konto der nächsten Person (Regel 10).
 * Wirft nie und wartet nie länger als `LOGOUT_FLUSH_BUDGET_MS`.
 */
export async function flushBeforeLogout(): Promise<void> {
  if (!navigator.onLine) return;
  let timer: ReturnType<typeof setTimeout> | undefined;
  // Nach der Frist läuft nichts im Hintergrund weiter: Sonst gingen Scans noch hinaus, wenn längst jemand anderes angemeldet ist
  const abort = new AbortController();
  const work = Promise.all([
    sendWaitingRegisters(),
    flushAllStations(currentPerson, helperApi, { signal: abort.signal }),
    flushAllIntakes(currentPerson, bazaarApi, { signal: abort.signal }),
  ]).then(
    () => undefined,
    () => undefined,
  );
  const limit = new Promise<void>((resolve) => {
    timer = setTimeout(() => {
      abort.abort();
      resolve();
    }, LOGOUT_FLUSH_BUDGET_MS);
  });
  try {
    await Promise.race([work, limit]);
  } finally {
    clearTimeout(timer);
  }
}
